import React from "react";
import MultiLocationModule from "./multiLocationModule";
import MultiLocationSagas from "./redux/multiLocationSagas";
import MultiLocationReducer from "./redux/multiLocationReducer";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";

const pageConfig = {
  pageName: "Multi Location",
  moduleList: [
    {
      Component: MultiLocationModule,
      moduleName: "multiLocation",
      saga: MultiLocationSagas(),
      reducer: MultiLocationReducer
    }
  ],
  hideConfigurator: true
};

const multiLocationUniversalPage = ({ notifications }) => {
  return <PageWithConfigurator pageConfig={pageConfig} notifications={notifications} />;
};

export default multiLocationUniversalPage;
